import {
    useEffect,
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import Select from "react-select";

import API from "../../services/api";

function AddPurchaseReturn() {

    const navigate =
        useNavigate();

    const [suppliers,
        setSuppliers] =
        useState([]);

    const [products,
        setProducts] =
        useState([]);

    const [wallets,
        setWallets] =
        useState([]);

    const [purchases,
        setPurchases] =
        useState([]);

    const [form,
        setForm] =
        useState({

            supplier_id: "",

            purchase_id: "",

            wallet_id: "",

            return_date:
                new Date()
                    .toISOString()
                    .split("T")[0],

            reason: ""

        });

    const [items,
        setItems] =
        useState([
            {
                product_id: "",
                qty: 1,
                price: 0,
                gst_percent: 0
            }
        ]);

    const selectStyles = {

        control: (base, state) => ({

            ...base,

            background: "#000",

            borderColor:
                state.isFocused
                    ? "#eab308"
                    : "#3f3f46",

            minHeight: 52,

            boxShadow: "none",

            "&:hover": {

                borderColor:
                    "#eab308"

            }

        }),

        menu: (base) => ({

            ...base,

            background: "#161616",

            border:
                "1px solid rgba(234,179,8,.25)",

            zIndex: 9999

        }),

        menuPortal: (base) => ({

            ...base,

            zIndex: 9999

        }),

        option: (
            base,
            state
        ) => ({

            ...base,

            background:
                state.isSelected
                    ? "#eab308"
                    : state.isFocused
                        ? "#333"
                        : "#161616",

            color:
                state.isSelected
                    ? "#000"
                    : "#fff"

        }),

        singleValue: (base) => ({

            ...base,

            color: "#fff"

        }),

        input: (base) => ({

            ...base,

            color: "#fff"

        }),

        placeholder: (base) => ({

            ...base,

            color: "#888"

        })

    };

    useEffect(() => {

        loadData();

    }, []);

    const loadData =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const headers = {

                    headers: {

                        Authorization:
                            `Bearer ${token}`

                    }

                };

                const [

                    supplierRes,

                    productRes,

                    walletRes,

                    purchaseRes

                ] = await Promise.all([

                    API.get(
                        "/suppliers",
                        headers
                    ),

                    API.get(
                        "/products",
                        headers
                    ),

                    API.get(
                        "/wallets",
                        headers
                    ),

                    API.get(
                        "/purchases",
                        headers
                    )

                ]);

                setSuppliers(
                    supplierRes.data.suppliers || []
                );

                setProducts(
                    productRes.data.products || []
                );

                setWallets(
                    walletRes.data.wallets || []
                );

                setPurchases(
                    purchaseRes.data.purchases || []
                );

            } catch (err) {

                console.log(err);

            }

        };

    const handleItemChange =
        (
            index,
            field,
            value
        ) => {

            const updated =
                [...items];

            updated[index][field] =
                value;

            setItems(updated);

        };

    const handleProductChange =
        (
            index,
            selected
        ) => {

            const product =
                products.find(
                    p =>
                        p.id ===
                        selected.value
                );

            const updated =
                [...items];

            updated[index] = {

                ...updated[index],

                product_id:
                    product.id,

                price:
                    product.purchase_price,

                gst_percent:
                    product.gst_percent

            };

            setItems(updated);

        };

    const addRow =
        () => {

            setItems([

                ...items,

                {

                    product_id: "",

                    qty: 1,

                    price: 0,

                    gst_percent: 0

                }

            ]);

        };

    const removeRow =
        (index) => {

            if (
                items.length === 1
            ) return;

            setItems(

                items.filter(
                    (_, i) =>
                        i !== index
                )

            );

        };

    const subtotal =
        items.reduce(

            (sum, item) =>

                sum +

                (
                    Number(item.qty) *
                    Number(item.price)
                ),

            0

        );

    const gstTotal =
        items.reduce(

            (sum, item) => {

                const amount =
                    Number(item.qty) *
                    Number(item.price);

                return (

                    sum +

                    (

                        amount *

                        Number(
                            item.gst_percent
                        ) / 100

                    )

                );

            },

            0

        );

    const grandTotal =
        subtotal +
        gstTotal;

    const submit =
        async (e) => {

            e.preventDefault();

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                await API.post(

                    "/purchase-returns",

                    {

                        ...form,

                        items

                    },

                    {

                        headers: {

                            Authorization:
                                `Bearer ${token}`

                        }

                    }

                );

                navigate(
                    "/admin/purchase-returns"
                );

            } catch (err) {

                console.log(err);

            }

        };

    return (

        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-8
                "
            >
                Add Purchase Return
            </h1>

            <form
                onSubmit={submit}
                className="
                bg-[#111]
                rounded-2xl
                p-6
                "
            >
                {/* Header */}

                <div
                    className="
    grid
    md:grid-cols-2
    gap-5
    mb-8
    "
                >

                    {/* Supplier */}

                    <div>

                        <label
                            className="
            block
            mb-2
            font-medium
            "
                        >
                            Supplier
                        </label>

                        <Select
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder="Select Supplier"
                            options={
                                suppliers.map(
                                    supplier => ({

                                        value:
                                            supplier.id,

                                        label:
                                            `${supplier.supplier_name} (${supplier.phone})`

                                    })
                                )
                            }
                            value={
                                suppliers
                                    .filter(
                                        s =>
                                            Number(s.id) ===
                                            Number(form.supplier_id)
                                    )
                                    .map(
                                        s => ({

                                            value:
                                                s.id,

                                            label:
                                                `${s.supplier_name} (${s.phone})`

                                        })
                                    )[0]
                            }
                            onChange={(selected) =>

                                setForm({

                                    ...form,

                                    supplier_id:
                                        selected.value

                                })

                            }
                        />

                    </div>

                    {/* Purchase */}

                    <div>

                        <label
                            className="
            block
            mb-2
            font-medium
            "
                        >
                            Purchase
                            (Optional)
                        </label>

                        <Select
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            isClearable
                            placeholder="Select Purchase"
                            options={
                                purchases.map(
                                    purchase => ({

                                        value:
                                            purchase.id,

                                        label:
                                            `${purchase.invoice_no} - ${purchase.supplier_name}`

                                    })
                                )
                            }
                            value={
                                purchases
                                    .filter(
                                        p =>
                                            Number(p.id) ===
                                            Number(form.purchase_id)
                                    )
                                    .map(
                                        p => ({

                                            value:
                                                p.id,

                                            label:
                                                `${p.invoice_no} - ${p.supplier_name}`

                                        })
                                    )[0]
                            }
                            onChange={(selected) =>

                                setForm({

                                    ...form,

                                    purchase_id:
                                        selected
                                            ? selected.value
                                            : ""

                                })

                            }
                        />

                    </div>

                    {/* Wallet */}

                    <div>

                        <label
                            className="
            block
            mb-2
            font-medium
            "
                        >
                            Refund Wallet
                        </label>

                        <Select
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder="Select Wallet"
                            options={
                                wallets.map(
                                    wallet => ({

                                        value:
                                            wallet.id,

                                        label:
                                            `${wallet.wallet_name} (₹${Number(wallet.balance).toFixed(2)})`

                                    })
                                )
                            }
                            value={
                                wallets
                                    .filter(
                                        w =>
                                            Number(w.id) ===
                                            Number(form.wallet_id)
                                    )
                                    .map(
                                        w => ({

                                            value:
                                                w.id,

                                            label:
                                                `${w.wallet_name} (₹${Number(w.balance).toFixed(2)})`

                                        })
                                    )[0]
                            }
                            onChange={(selected) =>

                                setForm({

                                    ...form,

                                    wallet_id:
                                        selected.value

                                })

                            }
                        />

                    </div>

                    {/* Return Date */}

                    <div>

                        <label
                            className="
            block
            mb-2
            font-medium
            "
                        >
                            Return Date
                        </label>

                        <input
                            type="date"
                            value={
                                form.return_date
                            }
                            onChange={(e) =>

                                setForm({

                                    ...form,

                                    return_date:
                                        e.target.value

                                })

                            }
                            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
                        />

                    </div>

                </div>

                {/* Return Reason */}

                <div
                    className="
    mb-8
    "
                >

                    <label
                        className="
        block
        mb-2
        font-medium
        "
                    >
                        Return Reason
                    </label>

                    <textarea
                        rows="4"
                        placeholder="Enter return reason..."
                        value={
                            form.reason
                        }
                        onChange={(e) =>

                            setForm({

                                ...form,

                                reason:
                                    e.target.value

                            })

                        }
                        className="
        w-full
        p-3
        rounded-xl
        bg-black
        border
        border-yellow-500/20
        "
                    />

                </div>

                {/* Product Table */}

                <div
                    className="
    overflow-x-auto
    "
                >

                    <table
                        className="
        w-full
        "
                    >

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >

                                <th className="p-3 text-left">
                                    Product
                                </th>

                                <th className="p-3 text-left">
                                    Qty
                                </th>

                                <th className="p-3 text-left">
                                    Price
                                </th>

                                <th className="p-3 text-left">
                                    GST %
                                </th>

                                <th className="p-3 text-left">
                                    Amount
                                </th>

                                <th className="p-3 text-left">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {items.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <tr
                                        key={index}
                                        className="
            border-b
            border-yellow-500/10
            "
                                    >

                                        {/* Product */}

                                        <td className="p-3 min-w-[320px]">

                                            <Select
                                                styles={selectStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                placeholder="Search Product..."
                                                options={
                                                    products.map(
                                                        product => ({

                                                            value:
                                                                product.id,

                                                            label:
                                                                `${product.name} (Stock: ${product.stock})`

                                                        })
                                                    )
                                                }
                                                value={
                                                    products
                                                        .filter(
                                                            p =>
                                                                Number(p.id) ===
                                                                Number(item.product_id)
                                                        )
                                                        .map(
                                                            p => ({

                                                                value:
                                                                    p.id,

                                                                label:
                                                                    `${p.name} (Stock: ${p.stock})`

                                                            })
                                                        )[0]
                                                }
                                                onChange={(selected) =>
                                                    handleProductChange(
                                                        index,
                                                        selected
                                                    )
                                                }
                                            />

                                        </td>

                                        {/* Qty */}

                                        <td className="p-3">

                                            <input
                                                type="number"
                                                min="1"
                                                value={item.qty}
                                                onChange={(e) =>

                                                    handleItemChange(

                                                        index,

                                                        "qty",

                                                        e.target.value

                                                    )

                                                }
                                                className="
                    w-24
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                                            />

                                        </td>

                                        {/* Price */}

                                        <td className="p-3">

                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={item.price}
                                                onChange={(e) =>

                                                    handleItemChange(

                                                        index,

                                                        "price",

                                                        e.target.value

                                                    )

                                                }
                                                className="
                    w-32
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                                            />

                                        </td>

                                        {/* GST */}

                                        <td className="p-3">

                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={item.gst_percent}
                                                onChange={(e) =>

                                                    handleItemChange(

                                                        index,

                                                        "gst_percent",

                                                        e.target.value

                                                    )

                                                }
                                                className="
                    w-24
                    p-3
                    rounded-xl
                    bg-black
                    border
                    border-yellow-500/20
                    "
                                            />

                                        </td>

                                        {/* Amount */}

                                        <td
                                            className="
                p-3
                font-bold
                text-green-400
                "
                                        >
                                            ₹
                                            {(
                                                Number(item.qty) *
                                                Number(item.price)
                                            ).toFixed(2)}
                                        </td>

                                        {/* Remove */}

                                        <td className="p-3">

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    removeRow(
                                                        index
                                                    )
                                                }
                                                className="
                    bg-red-500
                    hover:bg-red-600
                    px-4
                    py-2
                    rounded-xl
                    transition
                    "
                                            >
                                                Remove
                                            </button>

                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

                {/* Add Product */}

                <div
                    className="
    mt-5
    "
                >

                    <button
                        type="button"
                        onClick={addRow}
                        className="
        bg-blue-500
        hover:bg-blue-600
        px-6
        py-3
        rounded-xl
        transition
        "
                    >
                        + Add Product
                    </button>

                </div>

                {/* Totals */}

                <div
                    className="
    mt-8
    flex
    justify-end
    "
                >
                    <div
                        className="
    w-full
    md:w-96
    bg-black
    border
    border-yellow-500/20
    rounded-2xl
    p-6
    "
                    >

                        <div
                            className="
        flex
        justify-between
        mb-4
        "
                        >

                            <span>
                                Sub Total
                            </span>

                            <span>
                                ₹
                                {subtotal.toFixed(2)}
                            </span>

                        </div>

                        <div
                            className="
        flex
        justify-between
        mb-4
        "
                        >

                            <span>
                                GST Total
                            </span>

                            <span>
                                ₹
                                {gstTotal.toFixed(2)}
                            </span>

                        </div>

                        <div
                            className="
        border-t
        border-yellow-500/20
        pt-4
        flex
        justify-between
        text-2xl
        font-bold
        text-green-400
        "
                        >

                            <span>
                                Grand Total
                            </span>

                            <span>
                                ₹
                                {grandTotal.toFixed(2)}
                            </span>

                        </div>

                    </div>

                </div>

                {/* Buttons */}

                <div
                    className="
    flex
    gap-3
    mt-8
    flex-wrap
    "
                >

                    <button
                        type="submit"
                        className="
        bg-yellow-500
        hover:bg-yellow-400
        text-black
        font-semibold
        px-6
        py-3
        rounded-xl
        transition
        "
                    >
                        Save Purchase Return
                    </button>

                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                "/admin/purchase-returns"
                            )
                        }
                        className="
        bg-gray-700
        hover:bg-gray-600
        px-6
        py-3
        rounded-xl
        transition
        "
                    >
                        Cancel
                    </button>

                </div>

            </form>

        </div>

    );

}

export default AddPurchaseReturn;